import { render, staticRenderFns } from "./Carrinho.vue?vue&type=template&id=ddfd4c80&scoped=true&"
import script from "./Carrinho.vue?vue&type=script&lang=js&"
export * from "./Carrinho.vue?vue&type=script&lang=js&"
import style0 from "./Carrinho.vue?vue&type=style&index=0&id=ddfd4c80&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddfd4c80",
  null
  
)

export default component.exports